import { render, staticRenderFns } from "./ApiTokenCard.vue?vue&type=template&id=260c5978&"
import script from "./ApiTokenCard.vue?vue&type=script&lang=js&"
export * from "./ApiTokenCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports